import { useState, useEffect } from 'react';
import { apiClient } from '../utils/api';

export function useDiscoveryData(selectedDevice, selectedInterval, customRange = { start: '', end: '' }) {
    const [discoveryData, setDiscoveryData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!selectedDevice || !selectedInterval) {
            setDiscoveryData([]);
            return;
        }

        if (selectedInterval === 'custom') {
            if (!customRange?.start || !customRange?.end) {
                setDiscoveryData([]);
                return;
            }
        }

        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                const extraParams =
                    selectedInterval === 'custom' && customRange?.start && customRange?.end
                        ? { dt_start: customRange.start, dt_end: customRange.end }
                        : {};

                const data = await apiClient.getDiscoveryReport(selectedDevice, selectedInterval, extraParams);
                // Data is now an array
                setDiscoveryData(Array.isArray(data) ? data : []);

            } catch (err) {
                console.error('Error fetching discovery data:', err);
                if (err?.status === 403) {
                    setError('You do not have permission to view this data.');
                } else if (err?.status === 401) {
                    setError('Session expired. Please sign in again.');
                } else if (err?.status === 404) {
                    setDiscoveryData([]); // No scans found is not necessarily an error now
                } else {
                    setError(err.message);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [selectedDevice, selectedInterval, customRange?.start, customRange?.end]);

    return { discoveryData, loading, error };
}
